import { useEffect } from "react";
import i18n from "i18next";
import {
  initReactI18next,
  useTranslation as useTransAlias,
} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  Locales,
  LANGUAGE_COOKIE,
  getOptions,
  supportedLocales,
} from "./settings";
import { useLocale } from "../hooks/locale-provider";
import resourcesToBackend from "i18next-resources-to-backend";
import i18next from "i18next";

const runsOnServerSide = typeof window === "undefined";

// Initialize i18next for the client side
i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend(
      (lang: string, ns: string) => import(`./locales/${lang}/${ns}.json`)
    )
  )
  .init({
    ...getOptions(),
    // lng: undefined, // detect the language on the client
    lng: undefined, // detect the language on the client
    detection: {
      order: ["cookie"],
      lookupCookie: LANGUAGE_COOKIE,
      caches: ["cookie"],
      cookieOptions: {
        sameSite: "none",
        secure: true,
      },
    },
    preload: runsOnServerSide ? supportedLocales : [],
  });

export default i18n;
